<template>
    <div v-if="isVisible" class="modal-overlay">
        <div class="modal">
            <div class="modal-header">
                <h3 class="modal-title">{{ title }}</h3>
                <div class="modal-close" @click="closeModal">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
                            fill="var(--color-close-button)" />
                    </svg>
                </div>
            </div>
            <div class="modal-content">
                <slot></slot>
            </div>
            <div class="modal-footer">
                <ButtonComponent v-if="primaryAction" :content="primaryButtonText" @click="primaryAction" />
                <ButtonComponent v-if="secondaryAction" type="primary" :content="secondaryButtonText"
                    @click="secondaryAction" />
            </div>
        </div>
    </div>
</template>

<script>
import ButtonComponent from './ButtonComponent.vue';

export default {
    components: {
        ButtonComponent
    },
    name: 'ModalComponent',
    props: {
        isVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        primaryButtonText: {
            type: String,
            default: 'OK'
        },
        secondaryButtonText: {
            type: String,
            default: 'Cancel'
        },
        primaryAction: {
            type: Function,
            required: false
        },
        secondaryAction: {
            type: Function,
            required: false,
        },
        closeAction: {
            type: Function,
            required: true,
        }
    },
    data() {
        return {
            escEvent: null
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
            if (this.closeAction) {
                this.closeAction();
            }
        }
    },
    created() {
        this.escEvent = (evt) => {
            if (evt.key === 'Escape') {
                this.closeAction();
                console.log('Escape key pressed');
            }
        };
    },
    watch: {
        isVisible(newVal) {
            if (newVal) {
                document.addEventListener('keyup', this.escEvent);
            } else {
                document.removeEventListener('keyup', this.escEvent);
            }
        }
    },
    unmounted() {
        document.removeEventListener('keyup', this.escEvent);
    }
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.modal {
    background: var(--background);
    border-radius: 5px;
    width: 500px;
    max-width: 100%;
    padding-right: 20px;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.modal-title {
    margin: 0;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-content {
    margin: 20px 0;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
}

.modal-footer button {
    margin-left: 10px;
}

.modal-close {
    cursor: pointer;
    --color-close-button: white;

    &:hover {
        --color-close-button: var(--primary);
    }
}

@media (max-width: 768px) {
    .modal {
        width: 90%;
        max-width: 90%;
        padding: 12px 16px;
        margin: 1rem;
    }

    .modal-content {
        margin: 16px 0;
    }

    .modal-footer {
        flex-direction: column;
        gap: 8px;
    }

    .modal-footer button {
        margin-left: 0;
        width: 100%;
    }
}
</style>